/**
 * Card component - Premium SaaS style
 */

import {HTMLAttributes, forwardRef} from 'react';
import {cn} from '../../utils/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass';
  hover?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({className, variant = 'default', hover = false, ...props}, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#252526]',
          {
            // Default variant
            'bg-white dark:bg-[#252526]': variant === 'default',
            
            // Glass variant
            'glass border-gray-200/50 dark:border-gray-700/50': variant === 'glass',
            
            // Hover effects
            'transition-all duration-300': hover,
            'hover:shadow-xl hover:shadow-gray-200/50 dark:hover:shadow-black/50 hover:border-gray-300 dark:hover:border-gray-600 hover:-translate-y-1': hover,
          },
          className
        )}
        {...props}
      />
    );
  }
);

Card.displayName = 'Card';

